<template>
  <form-section>
    <p class="item-description">
      {{ $t('Integrations_Lithium_Text_Overview') }}
    </p>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'

export default {
  name: 'LithiumOverview',

  components: {
    FormSection
  },

  props: {
    model: {
      required: false
    }
  }
}
</script>

<style scoped>
.item-description {
  color: #808080;
  font-size: 12px;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/lithium/LithiumOverview.vue